var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.83333,
    stroke: "#E8D639"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 25.3333C21.1538 25.3333 25.333 21.1542 25.333 16C25.333 10.8458 21.1538 6.66666 15.9997 6.66666C10.8455 6.66666 6.66634 10.8458 6.66634 16C6.66634 21.1542 10.8455 25.3333 15.9997 25.3333ZM15.9997 8.24999C20.2788 8.24999 23.7497 11.7208 23.7497 16C23.7497 20.2792 20.2788 23.75 15.9997 23.75C11.7205 23.75 8.24967 20.2792 8.24967 16C8.24967 11.7208 11.7205 8.24999 15.9997 8.24999Z",
    fill: "#E8D639"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8503 11.2108C12.706 11.2108 12.5879 11.3289 12.5879 11.4733V20.5268C12.5879 20.6711 12.706 20.7892 12.8503 20.7892H13.9164C14.0607 20.7892 14.1788 20.6711 14.1788 20.5268V17.3941H16.2552C18.2037 17.3941 19.4108 16.1181 19.4108 14.3074C19.4108 12.5197 18.2201 11.2141 16.2618 11.2141H12.8503V11.2108ZM17.7909 14.3041C17.7909 15.7277 16.9217 16.0853 15.4554 16.0853H14.1794V12.5295H16.0229C17.1316 12.5295 17.7909 13.1757 17.7909 14.3041Z",
    fill: "#E8D639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParked);
export default __webpack_public_path__ + "static/media/parked.48521d2e53088b24b5f0218fd8ca5fef.svg";
export { ForwardRef as ReactComponent };